
let navigateFn: (to: string, options?: any) => void;

export const setNavigator = (fn: typeof navigateFn) => {
    navigateFn = fn;
};

export const navigate = (to: string, options?: any) => {
    if (navigateFn) {
        navigateFn(to, options);
    } else {
        console.warn("Navigation attempted before router initialized");
    }
};
